import React, { PropsWithChildren } from 'react';
import desktop_ribbon from 'assets/ribbon_desktop.svg';
import mobile_tablet_ribbon from 'assets/ribbon_tablet_mobile.svg';
import {
  Curve,
  Heading,
  ImageWrapper,
  MobileCurve,
  PageWrapper,
  Subhead,
  Wrapper,
} from './styles';

export type HeroWavedProps = {
  heading: string;
  subhead?: string;
};

const HeroRibbon: React.FC<PropsWithChildren<HeroWavedProps>> = ({
  heading,
  subhead,
  children,
}) => {
  const Content = (): JSX.Element => (
    <div tabIndex={0}>
      <Heading>{heading}</Heading>
      {subhead && <Subhead html={subhead} />}
    </div>
  );

  return (
    <Wrapper>
      <PageWrapper>
        <Content />
        {children}
      </PageWrapper>
      <ImageWrapper role="banner">
        <Curve role="img" aria-label="Curve" backgroundUrl={desktop_ribbon} />
        <MobileCurve
          role="img"
          aria-label="Mobile Curve"
          backgroundUrl={mobile_tablet_ribbon}
        />
      </ImageWrapper>
    </Wrapper>
  );
};

export default React.memo(HeroRibbon);
